import { Component, OnInit, OnDestroy, ViewChild } from '@angular/core';
import { DatePipe, Location } from '@angular/common';
import { PlycaDataService } from '../../../services/plyca.service';
import { ActivatedRoute, Router } from '@angular/router';
import { getSimpleIdentifierFromString, MasterDataDTO } from '../../api/plyca-dtos';
import { UserService } from '../../user.service';
import { generateRandomIdentifier, UIService } from '../../ui.service';
import { forkJoin, Observable, of } from 'rxjs';
import { SelectItem } from 'primeng-lts/api';
import { Configuration } from '../../conf/app.constants';
import { TranslateService } from '@ngx-translate/core';
import {
  CommunicationDTO, CommunicationStatusDTO,
  CommunicationStatusType, CommunicationDirectionType,
  CommunicationAgentDTO, CommunicationChannelDTO, CommunicationActivityDTO, ProjectEntityDTO
} from '../../api/plyca-dtos-v2';
import { HeaderActionsService } from '../../components/common/sub-header/header-actions.service';
import { WaitLoadingService } from '../../components/common/waitLoading/wait-loading.service';
import { finalize, tap } from 'rxjs/operators';
import { ALL_ELEMENTS_SIZE, PaginationDTO } from '../../api/PaginationModel';
import { AppConfiguration } from '../../conf/app.configuration';
import { BaseComponent } from '../../components/common/baseComponent/base.component';
import { PropertyService } from '../../properties/property.service';
import { Store } from '@ngrx/store';
import { CommunicationsViewPrefs, DossierCommunicationsPrefs, UserPrefs } from '../../api/UserPrefs-dto';
import { AppState } from '../../store/AppState';
import { SET_USERPREFS } from '../../store/userPrefs';
import { FormConfig } from '../../components/forms/form.objects';
import { formPlycaComponent } from '../../components/forms/formPlyca.component';
import { DialogService } from 'primeng-lts/dynamicdialog';
import { HttpParams } from '@angular/common/http';
import * as lodash from 'lodash';
import { UserPrefsService } from '../../store/user-prefs.service';

export class CommunicationsChannel {
  channel: CommunicationChannelDTO;
  communications: Array<CommunicationDTO>;

  constructor(channel: CommunicationChannelDTO) {
    this.channel = channel;
    this.communications = [];
  }

}

const COMMUNICATIONSERVICE_EXPANSION_VALUE = 'expansionSet:web.collection';

@Component({
  selector: 'communications',
  templateUrl: 'communications.template.html',
  providers: [DialogService, DatePipe]
})
export class CommunicationsComponent extends BaseComponent implements OnInit, OnDestroy {

  loaded = false;
  showHeader: boolean;
  preservePrefs = false;
  projectId: string;
  project: ProjectEntityDTO;

  // lista de comunicaciones agrupadas por canal
  classifiedComunications: Array<CommunicationsChannel>;
  // pestanya de comunicaciones de un canal seleccionada
  public selectedTab = 0;
  // visualizacion popup seleccion de actividad de nueva comunicacion
  public activitySelectionVisible = false;
  // public activities: CommunicationActivityDTO[];
  public activities: SelectItem[];
  public activitySelection: CommunicationActivityDTO;
  // propiedades auxiliares de la tabla de comunicaciones
  public colHeaders: string[];
  public expandedRows: [];
  PERFILVALIDO = false;
  // INFORMACION DE LA PANTALLA ALMACENADA EN SESION
  private userPrefs: UserPrefs;

  // Filtros
  filtersVisible = false;
  aceptar: boolean;
  @ViewChild('formPlycaRef') formPlycaRef1: formPlycaComponent;
  formConfigFilters: FormConfig;
  public filterWindowHash: string;
  activeFilters: Array<any> = [];
  hiddenActiveFilters: HttpParams;
  ptableConf: {
    first: number,
    rows: number
  };

  constructor(
    public plycaService: PlycaDataService,
    public userService: UserService,
    public uiService: UIService,
    public translateService: TranslateService,
    public route: ActivatedRoute,
    public router: Router,
    private headerActionsService: HeaderActionsService,
    public configuration: Configuration,
    private appConfig: AppConfiguration,
    private waitService: WaitLoadingService,
    private propertyService: PropertyService,
    private location: Location,
    private store: Store<AppState>,
    private datePipe: DatePipe,
    private userPrefsService: UserPrefsService
  ) {
    super();


    this.filterWindowHash = generateRandomIdentifier();

    this.subscribe(route.params,
      params => {
        this.projectId = params['id'];
      });
    this.resetHiddenFilters();





    this.colHeaders = [
      '',
      this.translateService.instant('Communications.table.subject'),
      this.translateService.instant('Communications.table.to'),
      this.translateService.instant('Communications.table.status'),
      this.translateService.instant('Communications.table.date'),
      this.translateService.instant('Communications.table.registerInfo'),
      this.translateService.instant('General.actions')
    ];

    this.ptableConf = {
      first: 0,
      rows: 20
    };

    this.subscribe(this.userPrefsService.getUserPrefs(),
      (prefs: UserPrefs) => {
        this.userPrefs = prefs;
        this.initPrefs();

        // seleccion de pestanya activa
        this.subscribe(this.route.queryParams,
          params => {
            if (params.tab) {
              this.userPrefs.communicationsViewPrefs.prefs.get(this.projectId).activeChannelTab = params.tab;
            }

          });
        if (!this.userPrefs.communicationsViewPrefs.prefs.get(this.projectId)._filters
          || JSON.stringify(this.userPrefs.communicationsViewPrefs.prefs.get(this.projectId)._filters) == '{}') {
          this.userPrefs.communicationsViewPrefs.prefs.get(this.projectId)._filters = {
          };
        }

        if (!this.userPrefs.communicationsViewPrefs.prefs.get(this.projectId).pageInfo
          || JSON.stringify(this.userPrefs.communicationsViewPrefs.prefs.get(this.projectId).pageInfo) == '{}') {
          this.userPrefs.communicationsViewPrefs.prefs.get(this.projectId)._filters = {
          };
        }

        this.ptableConf = {
          first: this.userPrefs.communicationsViewPrefs.prefs.get(this.projectId).pageInfo.number,
          rows: this.userPrefs.communicationsViewPrefs.prefs.get(this.projectId).pageInfo.size
        };


        this.updateActiveFilters();

      });
  }

  ngOnInit(): void {

    this.subscribe(this.createFormConfigFilters(),
      (form1: FormConfig) => {
        this.formConfigFilters = form1;



        // Se habilita la edición solo para los perfiles configurados
        this.subscribe(
          this.propertyService.getProperty('PERFILES_VALIDOS_NOTIFICACION')
            .pipe(
              tap(
                (perfiles) => {
                  if (perfiles) {
                    perfiles = perfiles.replace(new RegExp(/[;]/g), ',');
                    if (this.userService.hasRoles(perfiles)) {
                      this.PERFILVALIDO = true;
                    }

                  }

                }


              ),
              finalize(() => {
                this.subscribe(this.load(),
                  result => {
                    this.headerActionsService.clearActions();
                    // Filtros
                    this.subscribe(this.headerActionsService
                      .addAction(
                        'General.filters',
                        'fas fa-filter',
                        'btn-primary',
                        true
                      ),
                      () => {
                        this.aceptar = false;
                        this.filtersVisible = true;
                      });
                    this.subscribe(this.headerActionsService
                      .addWindowAction(
                        'General.search.text',
                        'fas fa-lg fa-search',
                        'btn-primary',
                        true,
                        this.filterWindowHash
                      ),
                      () => {
                        this.aceptar = true;
                        this.filtersVisible = false;
                        this.updateActiveFilters();
                      });
                    this.subscribe(this.headerActionsService
                      .addWindowAction(
                        'General.clean',
                        'fas fa-lg fa-undo',
                        'btn-secondary',
                        true,
                        this.filterWindowHash
                      ),
                      () => {
                        this.clear();
                      });
                    if (this.PERFILVALIDO) {
                      this.subscribe(this.headerActionsService.addAction(
                        'Communications.actions.new',
                        'far fa-lg fa-envelope',
                        'btn-primary',
                        this.isSelectedChannelEditable.bind(this)
                      ),
                        () => {
                          this.showActivitySelection();
                        });
                    }

                    this.subscribe(this.headerActionsService.addAction(
                      'General.reload',
                      'fas fa-lg fa-sync-alt',
                      'btn-primary',
                      true
                    ),
                      () => {
                        this.subscribe(this.load());
                      });
                    this.headerActionsService.addDivider();
                    this.subscribe(this.headerActionsService.addAction(
                      'General.back',
                      'fas fa-chevron-left',
                      'btn-outline-secondary',
                      true
                    ),
                      () => {
                        this.uiService.routeBack();
                      });
                  }
                );
              }

              )
            )

        );
      });
  }

  ngOnDestroy() {
    this.headerActionsService.clearActions();
    this.headerActionsService.clearWindowActions(this.filterWindowHash);
    let thisUserPrefs = this.userPrefs;
    this.store.dispatch(SET_USERPREFS({ userPrefs: thisUserPrefs }));

    super.ngOnDestroy();
  }

  public isSelectedChannelEditable(): boolean {
    let editableChannelsList = this.appConfig.getValue('communications.editable.channels') as Array<string>;
    return this.classifiedComunications && this.selectedTab > -1 && editableChannelsList
      .find(channel => channel === this.classifiedComunications[this.selectedTab].channel.identifier
        && this.classifiedComunications[this.selectedTab].channel.enabled) !== undefined;
  }

  public isChannelEditable(commChannel: CommunicationChannelDTO): boolean {
    let editableChannelsList = this.appConfig.getValue('communications.editable.channels') as Array<string>;
    return commChannel.enabled && this.classifiedComunications && editableChannelsList
      .find(channel => channel === commChannel.identifier) !== undefined;
  }

  public isChannelPermiteCopia(commChannel: CommunicationChannelDTO): boolean {
    return commChannel.properties && commChannel.properties.find(element =>
      element.key === 'PERMITECOPIA' && element.value.toUpperCase() === 'S') !== undefined;

  }


  public isPerfilValido() {
    return this.PERFILVALIDO;
  }

  private load(): Observable<any> {
    this.waitService.startWaiting();
    this.loaded = false;
    return forkJoin(
      this.plycaService.get<ProjectEntityDTO>(
        this.configuration.PROJECTENTITY_SERVICE_URL,
        this.projectId,
        this.getProjectEntityQueryParams()
      ),
      this.plycaService.query<CommunicationChannelDTO>(
        this.configuration.COMMUNICATIONCHANNEL_SERVICE_URL,
        this.getCommunicationChannelQueryParams()
      ),
      this.plycaService.query<CommunicationDTO>(
        this.configuration.COMMUNICATIONS_SERVICE_URL,
        this.getCommunicationQueryParamsHttpParams()
      )
    )
      .pipe(
        tap(result => {
          let resultIndex = 0;
          // datos del expediente
          this.project = result[resultIndex++] as ProjectEntityDTO;
          let queryData: PaginationDTO<any>;
          // canales
          queryData = result[resultIndex++] as PaginationDTO<CommunicationChannelDTO>;
          this.classifiedComunications = new Array<CommunicationsChannel>();
          if (queryData && queryData.content) {
            queryData.content.forEach((channel: CommunicationChannelDTO) =>
              this.classifiedComunications.push(new CommunicationsChannel(channel)));
            this.classifiedComunications = this.classifiedComunications.sort(this.classifiedComunicationsComparator.bind(this));
          }
          // comunicaciones
          queryData = result[resultIndex++] as PaginationDTO<CommunicationDTO>;
          if (queryData) {
            // TODO incluir este filtro de comunicaicones de canal visible en servidor
            queryData.content = queryData.content.filter(c => c.channel.visible);
            this.processCommunicationList(queryData.content);
          }
          // seleccion de pestanya activa
          let selectedTabIndex = -1;
          if (this.userPrefs.communicationsViewPrefs.prefs.get(this.projectId)?.activeChannelTab) {
            for (let i = 0; i < this.classifiedComunications.length && selectedTabIndex === -1; i++) {
              if (this.classifiedComunications[i].channel.identifier
                === this.userPrefs.communicationsViewPrefs.prefs.get(this.projectId)?.activeChannelTab) {
                selectedTabIndex = i;
              }
            }
          }
          if (selectedTabIndex === -1) {
            // seleccionar el primer canal con comunicaciones
            for (let i = 0; i < this.classifiedComunications.length && selectedTabIndex === -1; i++) {
              if (this.classifiedComunications[i].communications.length > 0) {
                selectedTabIndex = i;
              }
            }
          }
          if (selectedTabIndex !== -1) {
            this.selectedTab = selectedTabIndex;
          }

          this.userPrefs.communicationsViewPrefs.prefs.get(this.projectId).activeChannelTab
            = this.classifiedComunications[this.selectedTab].channel.identifier;
          this.loaded = true;
        }),
        finalize(() => this.waitService.cancelWaiting())
      )
  }

  public getCommunicationDate(communication: CommunicationDTO): Date {
    let commDate: Date;
    if (communication.status && communication.status.type === CommunicationStatusType.SENDED) {
      if (communication.direction === CommunicationDirectionType.OUT) {
        commDate = communication.sendedDate;
      } else {
        commDate = communication.creationDate;
      }
    } else {
      commDate = communication.creationDate;
    }
    return commDate;
  }

  private getCommunicationActivityQueryParams(channel: string, projectClass: string) {
    return {
      visible: 'true',
      channelId: channel,
      documentClassId: projectClass,
      sort: 'description',
      page: '0',
      size: ALL_ELEMENTS_SIZE,
      allowed: 'true',
      projectId: this.projectId

    };
  }

  private getProjectEntityQueryParams() {
    return {
      expand: 'expansionSet:minimal'
    };
  }

  private getCommunicationChannelQueryParams() {
    return {
      visible: 'true',
      sort: 'description',
      page: '0',
      size: ALL_ELEMENTS_SIZE,
      expand: 'expansionSet:PROPERTIES',
      projectId: this.projectId
    };
  }
  /*
    private getCommunicationQueryParams() {
      return {
        projectId: this.projectId,
        deleted: 'false',
        expand: 'expansionSet:web.collection'
      };
    }

  */
  getCommunicationQueryParamsHttpParams(): any { // { [param: string]: string | string[]; } {


    let serverFilters = lodash.cloneDeep(this.userPrefs.communicationsViewPrefs.prefs.get(this.projectId)._filters);
    //  let requestFilter =

    console.log(serverFilters);

    let params = Object.getOwnPropertyNames(serverFilters)
      .reduce((p, key) => {

        let value = this.userPrefs.communicationsViewPrefs.prefs.get(this.projectId)._filters[key];
        if (value != undefined && value !== '') {

          if (Array.isArray(value)) {
            let value1 = value.reduce((a, b) => a + b.identifier + ',', '');
            value1 = value1.slice(0, -1);
            return p.set(key, value1);
          } else if (value.identifier) {
            // si no es master data, la llamada a getSimpleIdentifierFromString no tiene efecto
            return p.set(key, getSimpleIdentifierFromString(value.identifier));
          } else if (value instanceof Date) {
            return p.set(key, '' + this.datePipe.transform(value, 'dd/MM/yyyy HH:mm:ss'));
          } else {
            return p.set(key, this.userPrefs.communicationsViewPrefs.prefs.get(this.projectId)._filters[key]);

          }
        } else {
          return p;

        }



      },
        this.hiddenActiveFilters


      );
    params = params.set('deleted', 'false');
    params = params.set('projectId', this.projectId);
    params = params.set('expand', COMMUNICATIONSERVICE_EXPANSION_VALUE);
    return params;
  }

  private processCommunicationList(communications: CommunicationDTO[]): void {
    // anyadir cada comunicacion a su canal
    communications
      .forEach(c => this.addSortField(c));
    communications
      .filter(c => !this.isResponseCommunication(c))
      .forEach(c => this.addCommunicationToChannelList(c));
    // asociar respuestas a cada comunicacione
    communications
      .filter(c => this.isResponseCommunication(c))
      .forEach(response => {
        let parentComm = communications.find(c => c.communicationUUID === response.repliedCommunication.communicationUUID);
        if (parentComm) {
          if (!parentComm.responses) {
            parentComm.responses = new Array<CommunicationDTO>();
          }
          parentComm.responses.push(response);
        } else {
          this.addCommunicationToChannelList(response, response.repliedCommunication?.channel?.identifier);
        }
      })
    this.expandedRows = this.getExpandedRows();
  }

  private addSortField(communication: CommunicationDTO): void {
    communication['sortField'] = this.getCommunicationDate(communication);
  }

  private addCommunicationToChannelList(c: CommunicationDTO, parentChannel?: string) {
    let commChannel = (parentChannel) ? parentChannel : c.channel.identifier;
    let channel: CommunicationsChannel = this.classifiedComunications.find(x => x.channel.identifier === commChannel);
    if (!channel) {
      channel = new CommunicationsChannel(c.channel);
      this.classifiedComunications.push(channel);
    }
    c.channel = channel.channel;
    channel.communications.push(c);
  }

  public getStatusIcon(status: CommunicationStatusDTO): string {
    let icon: string;
    if (status) {
      switch (status.type) {
        case CommunicationStatusType.EDITING: {
          icon = 'far fa-file-alt';
          break;
        } case CommunicationStatusType.SENDING: {
          icon = 'far fa-paper-plane';
          break;
        } case CommunicationStatusType.SENDED: {
          icon = 'far fa-check-circle';
          break;
        } case CommunicationStatusType.EXECUTION_PENDING: {
          icon = 'far fa-paper-plane';
          break;
        } case CommunicationStatusType.COMMUNICATION_ERROR: {
          icon = 'text-warning fas fa-exclamation-circle';
          break;
        } case CommunicationStatusType.ERROR: {
          icon = 'text-danger fas fa-exclamation-circle';
          break;
        } default: {
          icon = 'fa fa-question-circle-o';
        }
      }
    } else {
      icon = 'fa fa-question-circle-o';
    }
    return icon;
  }

  public getStatusTooltip(status: CommunicationStatusDTO): string {
    let key: string;
    if (status && status.type) {
      key = 'Communications.status.' + status.type;
    } else {
      key = 'General.undefined';
    }
    return this.translateService.instant(key);
  }

  public viewDetail(communication: CommunicationDTO): void {
    if (communication.status.type == CommunicationStatusType.EDITING) {
      this.router.navigate(['communications', communication.identifier], { queryParams: { edit: true } });
    } else {
      this.router.navigate(['communications', communication.identifier])
    }
  }

  public isErrorState(status: CommunicationStatusDTO): boolean {
    return status && status.type === CommunicationStatusType.COMMUNICATION_ERROR;
  }

  getChannelIcon(channel: MasterDataDTO): string {
    switch (channel.identifier) {
      default:
        return 'fab fa-product-hunt';
    }
  }

  public getAgentListDescription(communication: CommunicationDTO): string {
    let defaultDesc = ' ';
    let description: string;
    if (communication.direction === CommunicationDirectionType.OUT && communication.receivers) {
      description = CommunicationAgentDTO.getAgentListDescription(communication.receivers, defaultDesc);
    } else if (communication.direction === CommunicationDirectionType.IN && communication.sender) {
      description = CommunicationAgentDTO.getAgentDescription(communication.sender, defaultDesc);
    }
    return (description) ? description : defaultDesc;
  }

  public deleteFromList(communication: CommunicationDTO): void {
    // actulizar listado comunicaciones
    let channelCommList = this.classifiedComunications
      .find((comm: CommunicationsChannel) => comm.channel.identifier === communication.channel.identifier);
    channelCommList.communications = channelCommList.communications
      .filter((comm: CommunicationDTO) => comm.identifier !== communication.identifier)
  }


  private isResponseCommunication(c: CommunicationDTO): boolean {
    return c.repliedCommunication && c.repliedCommunication.communicationUUID && true;
  }

  /**
    * Devuelve identificadores de tabla para expandir
    */
  private getExpandedRows() {
    let expandedRow: any;
    expandedRow = {};
    if (this.classifiedComunications) {
      this.classifiedComunications.forEach((channelComm: CommunicationsChannel) => {
        channelComm.communications.filter((comm: CommunicationDTO) => !this.isResponseCommunication(comm))
          .forEach(
            (comm: CommunicationDTO) =>
              (expandedRow[comm.identifier.toString()] = comm.responses && comm.responses.length > 0)
          );
      });
    }
    return expandedRow;
  }

  public getNumberOfCommunications(communications: Array<CommunicationDTO>): number {
    let numberOfComm = 0;
    if (communications) {
      numberOfComm = communications.length;
      communications
        .filter(c => c.responses)
        .forEach(c => numberOfComm += this.getNumberOfCommunications(c.responses));
    }
    return numberOfComm;
  }

  public handleChangeTab(e: { originalEvent: Event, index: number }) {
    if (this.loaded && e.index > -1) {
      this.selectedTab = e.index;
      this.userPrefs.communicationsViewPrefs.prefs.get(this.projectId).activeChannelTab
        = this.classifiedComunications[this.selectedTab].channel.identifier;
      this.resetHiddenFilters();
      // anyadimos la informacion de la pestanya seleccionada a la ruta
      this.location.replaceState(this.router.createUrlTree([],
        { /* Removed unsupported properties by Angular migration: skipLocationChange. */ relativeTo: this.route,
          queryParams: {
            tab: this.classifiedComunications[e.index].channel.identifier,
            component: 'COMMUNICATIONS'
          },
          queryParamsHandling: 'merge'
        }).toString()
      );
    }
  }

  public newCommunication(): void {
    if (!this.activitySelection) {
      this.uiService.showMessage(this.translateService.instant('Communications.activitySelection.msg.errSelection'), 'General.info')
    } else {
      this.router.navigate(['communications',
        this.projectId,
        this.classifiedComunications[this.selectedTab].channel.identifier,
        this.activitySelection.identifier],
        { queryParams: { edit: true } });
    }
  }

  public showActivitySelection(): void {
    this.activitySelection = undefined;
    if (this.selectedTab > -1) {
      // consultar actividades del canal seleccionado
      let channel = this.classifiedComunications[this.selectedTab].channel.identifier;
      this.waitService.startWaiting();
      this.subscribe(this.plycaService.query<CommunicationActivityDTO>(
        this.configuration.COMMUNICATIONACTIVITY_URL,
        this.getCommunicationActivityQueryParams(channel, this.project.documentClass.identifier)
      ),
        (activities: PaginationDTO<CommunicationActivityDTO>) => {
          // mostrar ventana de seleccion
          if (activities) {
            this.activities = [];
            if (activities.page && activities.page.totalElements > 1) {
              // this.activities = activities.content;
              activities.content.forEach((activity: CommunicationActivityDTO) => this.activities.push(this.activityToSelectItem(activity)));
              this.activitySelectionVisible = true;
            } else {
              this.activitySelection = activities.content[0];
              this.newCommunication();
            }
          } else {
            this.uiService.showMessage(this.translateService.instant('Communications.activitySelection.msg.noActivity'),
              this.translateService.instant('General.error'),
              'errorStyle');
          }
          this.waitService.cancelWaiting();
        },
        (error: any) => {
          this.uiService.showGeneralErrorMessage();
          console.error('Error al obtener las actividades del canal ', error);
          this.waitService.cancelWaiting();
        }
      );
    }
  }

  private activityToSelectItem(activity: CommunicationActivityDTO): SelectItem {
    let item = {
      label: activity.description,
      value: activity
    }
    return item;
  }

  public closeActivitySelection(): void {
    this.activitySelectionVisible = false;
  }



  initPrefs() {

    // inicializar la variable por si no viene en las preferencias
    if (!this.userPrefs) {
      this.userPrefs = new UserPrefs();
    }
    if (!this.userPrefs.communicationsViewPrefs) {
      this.userPrefs.communicationsViewPrefs = new CommunicationsViewPrefs();
    }
    if (!(this.userPrefs.communicationsViewPrefs.prefs instanceof Map)) {
      this.userPrefs.communicationsViewPrefs.prefs = new Map<string, DossierCommunicationsPrefs>();
    }
    if (!this.userPrefs.communicationsViewPrefs.prefs.has(this.projectId)) {
      this.userPrefs.communicationsViewPrefs.prefs.set(this.projectId, new DossierCommunicationsPrefs());
    }




  }

  // Fitros
  public onCloseFilters() {
    if (this.aceptar) {
      this.subscribe(this.load());
    }
    this.filtersVisible = false;
  }

  // Modal de filtros
  private createFormConfigFilters(): Observable<FormConfig> {
    this.resetFilters();


    // Se estable el filtro como model
    return of(new FormConfig(undefined,
      'dossierCommSearchFiltersISettings.json',
      this.userPrefs.communicationsViewPrefs.prefs.get(this.projectId)._filters
    ));
  }
  resetFilters() {
    this.userPrefs.communicationsViewPrefs.prefs.get(this.projectId)._filters.projectId = this.projectId;
    this.subscribe(this.route.queryParams, (queryParams => {
      if (queryParams['activity']) {
        // this.hiddenActiveFilters = this.hiddenActiveFilters.append('activityIds', queryParams['activity']);
        let id: string;
        id = queryParams['activity'] + '';
        this.subscribe(this.plycaService.get(this.configuration.COMMUNICATIONACTIVITY_URL, queryParams['activity'],
          {

          }), param => {
            this.userPrefs.communicationsViewPrefs.prefs.get(this.projectId)._filters.activityIds = [
              {
                description: param['description'],
                identifier: id
              }
            ];
            this.updateActiveFilters();
          });

      }
      if (queryParams['agent']) {
        this.userPrefs.communicationsViewPrefs.prefs.get(this.projectId)._filters.agent = queryParams['agent'];
      }
      this.updateActiveFilters();
    }));

  }


  public clear() {
    this.resetHiddenFilters();
    Object.keys(this.userPrefs.communicationsViewPrefs.prefs.get(this.projectId)._filters)
      .forEach(key => delete this.userPrefs.communicationsViewPrefs.prefs.get(this.projectId)._filters[key]);
    this.userPrefs.communicationsViewPrefs.prefs.get(this.projectId)._filters.projectId = this.projectId;
    this.aceptar = true;
    this.filtersVisible = false;
    this.updateActiveFilters();

  }
  resetHiddenFilters() {
    this.hiddenActiveFilters = new HttpParams();
    this.hiddenActiveFilters = this.hiddenActiveFilters.append('expand', COMMUNICATIONSERVICE_EXPANSION_VALUE);
    this.hiddenActiveFilters = this.hiddenActiveFilters.append('deleted', 'false');
    //   this.hiddenActiveFilters.getAll();
  }


  updateActiveFilters() {
    let params = [];
    Object.getOwnPropertyNames(this.userPrefs.communicationsViewPrefs.prefs.get(this.projectId)._filters).forEach(key => {
      let value = this.userPrefs.communicationsViewPrefs.prefs.get(this.projectId)._filters[key];
      if (value != undefined && value != '') {
        let label = this.translateService.instant('Communications.filter.' + key);
        if (Array.isArray(value)) {
          let value1 = value.reduce((a, b) => a + b.description + ', ', '');
          value1 = value1.slice(0, -2);
          params.push({ 'label': label, 'key': key, 'value': value1 });
        } else if (value.identifier) {
          let desc = value.description;
          if (!desc && value.person) {
            desc = value.person.fullName;
          }
          if (!desc) {
            desc = value.name;
          }
          params.push({ 'label': label, 'key': key, 'value': desc });
        } else if (value instanceof Date) {
          // return p.set(key, '' + value.getTime());
          params.push({ 'label': label, 'key': key, 'value': this.datePipe.transform(value, 'dd/MM/yyyy') });
        } else {
          params.push({ 'label': label, 'key': key, 'value': value });
        }
      }
    });
    // this.numFilters = params.length;
    this.activeFilters = params;
  }

  removeFilter(filter) {
    console.log('REMOVING FILTER', filter);
    this.userPrefs.communicationsViewPrefs.prefs.get(this.projectId)._filters[filter.key] = undefined;
    this.updateActiveFilters();
    this.subscribe(this.load());
  }

  private classifiedComunicationsComparator(channel1: any, channel2: any): number {
    let value1 = channel1.channel.properties && channel1.channel.properties.find(element =>
      element.key === 'ORDEN_VISUALIZACION');
    let value2 = channel2.channel.properties && channel2.channel.properties.find(element =>
      element.key === 'ORDEN_VISUALIZACION');

    value1 = value1 !== undefined ? value1.value : 999;
    value2 = value2 !== undefined ? value2.value : 999;

    if (!value1 && !value2) {
      // son iguales
      return 0;
    } else if (!value1) {
      // doc1 va despues de doc2
      return -1;
    } else if (!value2) {
      // doc1 va antes que doc2
      return 1;
    } if (value1 < value2) {
      return -1;
    } else if (value1 > value2) {
      return 1;
    } else {
      return 0;
    }

  }


  onCommDetailWindow(comm: any) {
    this.preservePrefs = true;
  }


  savePages(ev: any) {
    this.userPrefs.communicationsViewPrefs.prefs.get(this.projectId).pageInfo.number = ev.first;
    this.userPrefs.communicationsViewPrefs.prefs.get(this.projectId).pageInfo.size = ev.rows;

  }
}
